module.exports = __webpack_public_path__ + "img/menu-login.fd2b3672.svg";